var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"s-waveMask",style:(_setup.containerStyle),attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"s-waveMask__bg"}),_c('div',{staticClass:"s-waveMask__played",style:(_setup.playedStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }